export default "__VITE_ASSET__53b4400f__"